<template>
  <Header headerShadow="header__area header__padding header__shadow" />
  <section class="page__title-area pt-90 pb-90">
    <div class="page__title-shape">
      <!-- <img class="page-title-shape-5 d-sm-block" src="../assets/img/page-title/page-title-shape-1.png" alt=""> -->
      <!-- <img class="page-title-shape-6" src="../assets/img/page-title/page-title-shape-6.png" alt=""> -->
      <!-- <img class="page-title-shape-7" src="../assets/img/page-title/page-title-shape-4.png" alt=""> -->
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="course__wrapper">
            <div class="page__title-content pt-90 mb-25">
              <div class="page__title-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/">{{ $t("actions.home") }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      {{ $t("navbar.rahbar") }}
                    </li>
                  </ol>
                </nav>
              </div>
              <h5 class="page__title-3" style="font-size: 35px">
                {{ $t("navbar.rahbar") }}
              </h5>
            </div>

            <div class="course__tab-content mb-65">
              <div class="tab-content" id="courseTabContent">
                <div
                  class="tab-pane fade show active mb-30"
                  id="description"
                  role="tabpanel"
                  aria-labelledby="description-tab"
                >
                  <div class="course__description">
                    <div class="row">
                      <LeaderCard
                        v-for="(vm, index) in sortedLeaders"
                        :key="index"
                        :leader="vm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <Footer footerPadding="true" />
</template>

<script>
import Header from "../components/HomeTwo/Header.vue";
import Footer from "../components/Home/Footer.vue";
import LeaderCard from "../components/Instructor/LeaderCard.vue";
import CourseItemMixin from "../mixins/courseItemsMixin";
// import CourseSidebar from '../components/CourseDetails/CourseSidebar.vue';
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper";
import { mapGetters, mapActions } from "vuex";
import BlogMixin from "@/mixins/blogMixin";
export default {
  name: "CourseDetailsPage",
  components: {
    Swiper,
    SwiperSlide,
    Header,
    // CourseSidebar,
    Footer,
    LeaderCard,
  },
  mixins: [CourseItemMixin, BlogMixin],
  data() {
    return {
      course: [
        {
          image: "rahbarr",
          name: "Kichkilov Ravshan Xamzayevich",
          position: "actions.director",
          phone: "71 207 47 00",
          email: "z.egamova@atjem.antimon.gov.uz",
          freeTime: "actions.freeTime",
        },
        {
          image: "rahbar1",
          name: "Ochilov Bahrom Bo'riboyevich",
          position: "actions.zamDirector",
          phone: "71 207 47 00",
          email: "z.egamova@atjem.antimon.gov.uz",
          freeTime: "actions.freeTime1",
        },
        {
          image: "rahbar2",
          name: "Toshqulov Lazizbek Ruslan o'g'li",
          position: "actions.VVBDirector",
          phone: "71 207 47 00",
          email: "z.egamova@atjem.antimon.gov.uz",
          freeTime: "actions.freeTime",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("leader", ["leader"]),
    sortedLeaders() {
      if (!this.leader) return [];
      return [...this.leader].sort((a, b) => {
        return a.level - b.level;
      });
    },
  },
  created() {
    this.getLeader();
  },
  methods: {
    ...mapActions("leader", ["getLeader"]),
  },
};
</script>

<style scoped lang="css">
.course__description {
  width: 100%;
  padding: 40px 35px;
}

.circle__image {
  width: 230px;
  height: 230px;
  border-radius: 50%;
  margin: 20px;
  object-fit: cover;
  object-position: center;
  border: 1px solid rgba(128, 128, 128, 0.27);
  padding: 10px;
}
</style>
